import { IRateInitialState } from "../../../types/master/rateInterface";
import { RateActionTypes, RateActions } from "../../actionTypes/master/rateActionTypes";



const initialState: IRateInitialState = {
  rateList: [],
  rateData: {
    id: 0,
    origin_zone_id: 0,
    destination_zone_id: 0,
    service_mode: "",
    rate: 0,
  },
  rateListPageCount: 0,
};

export default function rateReducer(state = initialState, action: RateActionTypes): IRateInitialState {
  switch (action.type) {
    case RateActions.SET_RATE_LIST:
      return {
        ...state,
        rateList: action.payload,
      };

    case RateActions.SET_RATE_LIST_PAGE_COUNT:
      return {
        ...state,
        rateListPageCount: action.payload
      };

    case RateActions.SET_RATE_DATA_BY_ID:
      return {
        ...state,
        rateData: action.payload,
      };

    default:
      return state;
  }
}
